import React from 'react';
import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';
import theme from '../theme';
import texts from '../locales/texts';

// Keyframes for shooting stars
const shootingStar1 = keyframes`
  0% { transform: translate(0, 0) scale(0); opacity: 1; }
  80% { opacity: 1; }
  100% { transform: translate(60px, -60px) scale(1); opacity: 0; }
`;

const shootingStar2 = keyframes`
  0% { transform: translate(0, 0) scale(0); opacity: 1; }
  80% { opacity: 1; }
  100% { transform: translate(-50px, -70px) scale(1); opacity: 0; }
`;

const sparkle = keyframes`
  0%, 100% { opacity: 0; transform: scale(0) rotate(0deg); }
  50% { opacity: 1; transform: scale(1) rotate(180deg); }
`;

const glow = keyframes`
  0%, 100% { box-shadow: 0 4px 20px rgba(219, 39, 98, 0.4), 0 0 20px rgba(241, 222, 124, 0.3); }
  50% { box-shadow: 0 6px 30px rgba(219, 39, 98, 0.6), 0 0 30px rgba(241, 222, 124, 0.5); }
`;

const ButtonContainer = styled(motion.button)`
  padding: 16px 40px;
  border-radius: ${props => props.theme.borderRadius.medium};
  background: linear-gradient(135deg, ${props => props.theme.colors.secondary} 0%, #e8316d 50%, ${props => props.theme.colors.secondary} 100%);
  background-size: 200% 200%;
  color: white;
  font-size: 18px;
  font-weight: bold;
  border: 2px solid ${props => props.theme.colors.accent1};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  box-shadow: 0 4px 20px rgba(219, 39, 98, 0.4), 0 0 20px rgba(241, 222, 124, 0.3);
  transform: rotate(-2deg);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: visible;
  animation: ${glow} 3s ease-in-out infinite;

  &::before {
    content: '✨';
    position: absolute;
    font-size: 14px;
    top: -8px;
    left: 10px;
    animation: ${sparkle} 2s ease-in-out infinite;
    pointer-events: none;
  }

  &::after {
    content: '⭐';
    position: absolute;
    font-size: 12px;
    bottom: -6px;
    right: 15px;
    animation: ${sparkle} 2.5s ease-in-out infinite 0.5s;
    pointer-events: none;
  }

  &:hover {
    background-position: 100% 0;
    box-shadow: 0 8px 35px rgba(219, 39, 98, 0.5), 0 0 40px rgba(241, 222, 124, 0.4);
    transform: translateY(-5px) rotate(-1deg) scale(1.05);
    border-color: ${props => props.theme.colors.accent1};
    animation: none;
  }

  &:active {
    transform: translateY(-2px) rotate(-2deg) scale(1.02);
    box-shadow: 0 4px 20px rgba(219, 39, 98, 0.4);
  }
`;

const IconSpan = styled.span`
  margin-left: 8px;
  display: inline-block;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 20px;
  
  ${ButtonContainer}:hover & {
    transform: translateX(5px) scale(1.2);
  }
`;

const SparkleContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: visible;
`;

const Sparkle = styled.span`
  position: absolute;
  font-size: 10px;
  color: ${props => props.theme.colors.accent1};
  opacity: 0;
  animation: ${sparkle} 2s ease-in-out infinite;
  
  &:nth-child(1) {
    top: 20%;
    left: 15%;
    animation-delay: 0s;
  }
  
  &:nth-child(2) {
    top: 60%;
    right: 20%;
    animation-delay: 1s;
  }
  
  &:nth-child(3) {
    bottom: 25%;
    left: 25%;
    animation-delay: 0.5s;
  }
`;

const ProbeterminButton = ({ onClick }) => {
  return (
    <ButtonContainer
      
      onClick={onClick}
    >
      <SparkleContainer>
        <Sparkle>✨</Sparkle>
        <Sparkle>⭐</Sparkle>
        <Sparkle>✨</Sparkle>
      </SparkleContainer>
      {texts.probetermin}
      <IconSpan>→</IconSpan>
    </ButtonContainer>
  );
};

export default ProbeterminButton; 